export default __webpack_public_path__ + "static/media/logo.a7277bb9.png";